import React, {
  Component
} from 'react';
import {
  css
}
from 'emotion';

import {
  gridGutter,
  gridGutterHalf,
  fontSize16
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";
import {
  blue,
  grayFont
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";

let containerStyle = css`
    padding: ${gridGutterHalf}px ${gridGutter}px;
    color: ${blue};
    font-size: ${fontSize16};
    font-weight: 500;

    .summary-value {
      font-weight: bold;
      text-align: right;
    }

    small {
      color: ${grayFont};
    }
`;

export default class SummaryItem extends Component {
  render = () => {
    const {
      title,
      description,
      value,
      className
    } = this.props;
    return (
      <React.Fragment>            
        <div className={ `${containerStyle} ${className || ''}` }>
          <div className="row">
            <div className="col-xs-10">
                { title }<br />
                <small> { description } </small>
            </div>
            <div className='col-xs-6 summary-value'>{ value }</div>
          </div>
        </div>  
      </React.Fragment>
    );
  }
}